var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.innerComponent,_vm._b({tag:"component",on:{"success":function($event){return _vm.close()},"error":function($event){return _vm.close()},"close":function($event){return _vm.close()}}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }